import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import ModalContainer from "../../../containers/Modal/ModalContainer";
import { useGeneralContext } from "../../General/Context";
import i18next from "i18next";
import { ConfigSettings } from "../../../config/Config";
import UplodBase64 from "../../../components/Files/FileBase64";
const configSettings = ConfigSettings();
const ModalDownloadDocOnline = ({
  showModalDownloadDocOnline,
  setShowModalDownloadDocOnline,
  docOnlineId,
  downLoadDocOnline,
  candidateFullName,
  docOnlineService
}) => {
  const { t } = useTranslation();
  const { userInformation } = useGeneralContext();
  const [docOnlineLanguages, setDocOnlineLanguages] = useState([{}]);
  const [templates, setTemplates] = useState([{}]);
  const [parameters, setParameters] = useState({ downloadIsInPdf: false });
  const [errorMessage, setErrorMessage] = useState();

  useEffect(() => {
    docOnlineService
      .getVitaeLanguages()
      .then((data) => setDocOnlineLanguages(data));
    docOnlineService.getAllTemplates().then((data) => setTemplates(data));

    setParameters({
      ...parameters,
      templatePrefix: setTemplateprefix(),
      docOnlineId: docOnlineId,
      downloadIsInPdf: false,
      languageCode: i18next.language.substring(0, 2).toUpperCase()
    });
  }, [docOnlineId]);

  function setTemplateprefix() {
    if (
      templates
        .map((x) => x.templatePrefix)
        .includes(userInformation.companyAbbreviation) ||
      parameters.templatePrefix === undefined
    ) {
      return userInformation.companyAbbreviation;
    }
  }

  const onChange = ({ target }) => {
    setParameters({ ...parameters, [target.name]: target.value });
  };

  const closeModal = () => {
    setShowModalDownloadDocOnline(false);
  };

  const getFileName = () => {
    return `${candidateFullName.replace(" ", "_")}${
      parameters.downloadIsInPdf ? ".pdf" : ".docx"
    }`;
  };

  const submitButtonActionFunction = () => {
    if (!parameters.templatePrefix) {
      setErrorMessage(t("Please select a company"));
      return;
    } else {
      setErrorMessage();
    }

    downLoadDocOnline(
      parameters.templatePrefix,
      parameters.languageCode,
      parameters.downloadIsInPdf,
      getFileName(),
      parameters.docOnlineId,
      parameters.file
    ).then(() => {
      setShowModalDownloadDocOnline(false);
    });
  };

  const onChangeWordType = () => {
    setParameters({ ...parameters, downloadIsInPdf: false });
  };

  const onChangePDFType = () => {
    setParameters({ ...parameters, downloadIsInPdf: true });
  };
  function onFileLoad(file) {
    setParameters({ ...parameters, file: file[0] });
  }
  return (
    <ModalContainer
      modalSubtitle={t(
        "Enter the following information to select the template to print"
      )}
      isOpen={showModalDownloadDocOnline}
      submitButtonAction={submitButtonActionFunction}
      submitButtonTitle={t("Confirm")}
      submitButtonType="button"
      closeModal={closeModal}
      crossmarkAction={closeModal}
    >
      {(configSettings.environment === "DEV" ||
        configSettings.environment === "Local") && (
        <>
          {" "}
          <div className="form-group">
            <div className="label-wrapper">
              <label>{t("File For testing")}</label>
            </div>
            <UplodBase64
              afterLoadCallback={onFileLoad}
              accept="application/pdf, application/msword, text/xml, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              multiple={false}
            />{" "}
          </div>
        </>
      )}
      <div className="col-md-6">
        {" "}
        <div className="form-group">
          <div className="label-wrapper">
            <label>
              {t("Select a company")}
              <label className="star-style">*</label>{" "}
              <span className="error-msg">{errorMessage}</span>
            </label>
          </div>
          <select
            id="templatePrefix"
            name="templatePrefix"
            className="form-select"
            onChange={onChange}
            value={parameters.templatePrefix}
          >
            {templates.map((item) => (
              <option key={item.id} value={item.templatePrefix}>
                {t(item.description)}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <div className="label-wrapper">
            <label>{t("Choose a language")}</label>
          </div>
          <select
            id="languageCode"
            name="languageCode"
            className="form-select"
            onChange={onChange}
            value={parameters.languageCode}
          >
            {docOnlineLanguages.map((item) => (
              <option key={item.id} value={item.initials}>
                {t(item.languageDescription)}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <div className="label-wrapper">
            <label>{t("Document type")}</label>
          </div>
          <div className="form-check">
            <div>
              <input
                className="form-check-input"
                type="radio"
                name="downloadDOCOnline"
                id="PDF"
                onChange={onChangePDFType}
                checked={parameters.downloadIsInPdf}
              />
              <label htmlFor="PDF">{t("PDF")}</label>
            </div>
            <div>
              <input
                className="form-check-input"
                type="radio"
                name="downloadDOCOnline"
                id="WORD"
                onChange={onChangeWordType}
                checked={!parameters.downloadIsInPdf}
              />
              <label htmlFor="WORD">{t("WORD")}</label>
            </div>
          </div>
        </div>
      </div>
    </ModalContainer>
  );
};

export default ModalDownloadDocOnline;
